import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    inputnumber: {
        verticalAlign: 'initial',
        width: '30px',
        height: '30px',
        paddingLeft: '8px',
        paddingRight: '8px',
        borderRadius: '4px',
        boxShadow: '0 1px 0 0 hsl(0deg 0% 100% / 15%), inset 0 1px 0 0 rgb(0 0 0 / 15%)',
        backgroundColor: '#1c2542',
        color: '#fff',
        border: 0,
        outline: 'none'
    },
    countPage: {
        verticalAlign: 'initial',
        width: '30px',
        paddingLeft: '8px',
        color: '#fff',
        border: 0,
        outline: 'none',
        fontSize: 16
    },
    arrowleft: {
        cursor: 'pointer',
        padding: '5px 20px 5px 20px',
        userSelect: 'none',
        '-moz-user-select': 'none',
        '-webkit-user-select': 'none',
        color: '#0f3e67',
        background: 'none',
        border: '1px solid #0f3e67',
        borderRadius: 16,
        marginRight: 8,
    },
    arrowright: {
        cursor: 'pointer',
        padding: '5px 20px 5px 20px',
        userSelect: 'none',
        '-moz-user-select': 'none',
        '-webkit-user-select': 'none',
        color: '#0f3e67',
        background: 'none',
        border: '1px solid #0f3e67',
        borderRadius: 16,
    },
    select: {
        width: 50, 
        marginRight: 12,
        height: '32px',
        border: 0,
        background: '#293356',
        boxShadow: 'inset 0 1px 0 0 hsl(0deg 0% 100% / 20%)',
        color: '#fff',
        cursor: 'pointer',
        paddingLeft: 15,
        paddingRight: 0,
        overflow: 'hidden',
        textAlign: 'left',
        textDecoration: 'none',
        outline: 'none',
        lineHeight: '18px',
        position: 'relative',
        borderRadius: '4px',
    }
}));

export {
    useStyles,
}